export const LANDING = {
  hero: "landing-hero",
  ctaSurvey: "landing-cta-survey",
  ctaLearn: "landing-cta-learn",
  adminLink: "landing-admin-link",
  featureRoutes: "feature-routes",
  featureTimings: "feature-timings",
  featureFares: "feature-fares",
  scheduleTable: "landing-schedule-table",
  fareTable: "landing-fare-table",
};

export const SURVEY = {
  root: "survey-root",
  stepIndicator: "survey-step-indicator",
  emailInput: "survey-email-input",
  emailContinue: "survey-email-continue",
  emailPreviousBanner: "survey-previous-banner",
  emailStartNew: "survey-start-new",
  emailEditExisting: "survey-edit-existing",
  editingBanner: "survey-editing-banner",
  nameInput: "survey-name-input",
  phoneInput: "survey-phone-input",
  monthSelect: "survey-month-select",
  infoContinue: "survey-info-continue",
  routeCard: (id) => `survey-route-${id}`,
  routeContinue: "survey-route-continue",
  contactLeadName: "lead-name-input",
  contactLeadPhone: "lead-phone-input",
  contactLeadSubmit: "lead-submit",
  dayCard: (d) => `survey-day-${d.toLowerCase()}`,
  daysContinue: "survey-days-continue",
  tripCheckbox: (day, id) => `survey-trip-${day.toLowerCase()}-${id.toLowerCase()}`,
  tripsContinue: "survey-trips-continue",
  planCard: (id) => `survey-plan-${id}`,
  fareAgree: "survey-fare-agree",
  fareDisagree: "survey-fare-disagree",
  fareProposedInput: "survey-fare-proposed",
  paymentContinue: "survey-payment-continue",
  reviewSubmit: "survey-review-submit",
  reviewBack: "survey-review-back",
  successCard: "survey-success",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  monthFilter: "admin-month-filter",
  toggleSurvey: "admin-toggle-survey",
  kpiRespondents: "kpi-respondents",
  kpiRevenue: "kpi-revenue",
  kpiOccupancy: "kpi-occupancy",
  kpiPeak: "kpi-peak",
  dayChart: "chart-day-demand",
  tripChart: "chart-trip-demand",
  routeChart: "chart-route-demand",
  heatmap: "chart-heatmap",
  directionSplit: "chart-direction-split",
  directionCard: (day, dir) => `direction-${day.toLowerCase()}-${dir}`,
  responsesTable: "responses-table",
  exportCsv: "export-csv",
  resetBtn: "reset-btn",
  resetConfirm: "reset-confirm",
  banEmail: "ban-email-input",
  banSubmit: "ban-submit",
  bannedList: "banned-list",
  changePwOld: "change-pw-old",
  changePwNew: "change-pw-new",
  changePwSubmit: "change-pw-submit",
  aiForecastCard: "ai-forecast-card",
  aiForecastRefresh: "ai-forecast-refresh",
  logout: "admin-logout",
  leadsList: "leads-list",
  scheduleTab: "schedule-tab",
  semesterLabel: "semester-label",
  semesterStart: "semester-start",
  semesterEnd: "semester-end",
  semesterSave: "semester-save",
  scheduleMonthPrev: "schedule-month-prev",
  scheduleMonthNext: "schedule-month-next",
  scheduleDate: (iso) => `schedule-date-${iso}`,
};
